import { useMemo } from "react";
import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useNotifyPartySync } from "@RequestFormV2/sections/Schedule/hooks/useNotifyPartySync";
import {
  getNotifyPartySharedAddressFieldPaths,
  getNotifyPartySharedContactFieldPaths,
} from "@RequestFormV2/sections/Schedule/utils/notifyPartyFieldPaths";
import SharedAddressSection from "@RequestFormV2/sections/Schedule/components/shared/AddressSection";
import SharedContactSection from "@RequestFormV2/sections/Schedule/components/shared/ContactSection";
import NotifyPartySyncField from "@RequestFormV2/sections/Schedule/components/NotifyPartySection/NotifyPartySyncField";

export default function NotifyPartySection() {
  const intl = useIntl();
  const sync = useNotifyPartySync();

  const addressFieldPaths = useMemo(() => getNotifyPartySharedAddressFieldPaths(), []);
  const contactFieldPaths = useMemo(() => getNotifyPartySharedContactFieldPaths(), []);

  return (
    <div
      className="rfv2-form-section rfv2-schedule-notify-party"
      data-testid={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SECTION}
    >
      <FormSectionLabel
        label={intl.formatMessage({
          id: "new-request.schedule.notifyParty",
          defaultMessage: "Notify party",
        })}
        supportingText={intl.formatMessage({
          id: "new-request.schedule.notifyParty.optional",
          defaultMessage: "(Optional)",
        })}
      />

      <div className="rfv2-form-section__content rfv2-schedule-notify-party__fields">
        <NotifyPartySyncField sync={sync} />

        <div className="rfv2-form-section rfv2-form-section--nested">
          <SharedAddressSection
            fieldPaths={addressFieldPaths}
            contactFieldPaths={contactFieldPaths}
            fieldsDisabled={sync.fieldsDisabled}
            isRequired={false}
            testIdPrefix={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_ADDRESS_TYPE}
            portTestId={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_PORT_SELECT}
            addressSearchTestId={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_ADDRESS_SELECT}
            addressSearchPlaceholder={intl.formatMessage({
              id: "new-request.schedule.multistop.searchAddress",
              defaultMessage: "Select address",
            })}
          />
        </div>

        <SharedContactSection
          fieldPaths={contactFieldPaths}
          fieldsDisabled={sync.fieldsDisabled}
          isRequired={false}
          contactNameTestId={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_NAME}
          contactPhoneTestId={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_PHONE}
          contactEmailTestId={testIds.REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_EMAIL}
        />
      </div>
    </div>
  );
}
